export const DASHBOARD_ROUTE = "DASHBOARD_ROUTE";
export const LOGIN_ROUTE = "LOGIN_ROUTE";
export const SIGNUP_ROUTE = "SIGNUP_ROUTE";
export const FORGOT_PASSWORD_ROUTE = "FORGOT_PASSWORD_ROUTE";
export const MFA_VERIFY_ROUTE = "MFA_VERIFY_ROUTE";
export const RESET_PASSWORD_ROUTE = "RESET_PASSWORD_ROUTE";
export const VERIFY_EMAIL_ROUTE = "VERIFY_EMAIL_ROUTE";
export const EMAIL_VERIFICATION_WALL_ROUTE = "EMAIL_VERIFICATION_WALL_ROUTE";
export const ONBOARDING_ROUTE = "ONBOARDING_ROUTE";
export const CONTACTS_ROUTE = "CONTACTS_ROUTE";
export const CONTACT_OVERVIEW_ROUTE = "CONTACT_OVERVIEW_ROUTE";
export const CONVERT_CONTACT_OPPORTUNITY_ROUTE = "CONVERT_CONTACT_OPPORTUNITY_ROUTE";
export const CONTACT_IMPORT_ROUTE = "CONTACT_IMPORT_ROUTE";
export const COMPANIES_ROUTE = "COMPANIES_ROUTE";
export const COMPANY_OVERVIEW_ROUTE = "COMPANY_OVERVIEW_ROUTE";
export const BUCKETS_ROUTE = "BUCKETS_ROUTE";
export const BUCKETS_LIST_ROUTE = "BUCKETS_LIST_ROUTE";
export const DIALER_SESSION_ROUTE = "DIALER_SESSION_ROUTE";
export const DIALER_SESSION_HISTORY_ROUTE = "DIALER_SESSION_HISTORY_ROUTE";
export const DIALER_SESSION_DETAIL_ROUTE = "DIALER_SESSION_DETAIL_ROUTE";
export const OPPORTUNITIES_ROUTE = "OPPORTUNITIES_ROUTE";
export const OPPORTUNITY_OVERVIEW_ROUTE = "OPPORTUNITY_OVERVIEW_ROUTE";
export const MEETINGS_ROUTE = "MEETINGS_ROUTE";
export const TEMPLATE_FOLDERS_ROUTE = "TEMPLATE_FOLDERS_ROUTE";
export const TEMPLATES_ROUTE = "TEMPLATES_ROUTE";
export const SEQUENCES_ROUTE = "SEQUENCES_ROUTE";
export const SEQUENCE_CREATE_ROUTE = "SEQUENCE_CREATE_ROUTE";
export const SEQUENCE_DETAIL_ROUTE = "SEQUENCE_DETAIL_ROUTE";
export const ACTIVITY_REPORTS_ROUTE = "ACTIVITY_REPORTS_ROUTE";
export const REPORTS_ROUTE = "REPORTS_ROUTE";
export const CALL_HISTORY_REPORTS_ROUTE = "CALL_HISTORY_REPORTS_ROUTE";
export const OPPORTUNITIES_REPORTS_ROUTE = "OPPORTUNITIES_REPORTS_ROUTE";
export const SETTINGS_GENERAL_ROUTE = "SETTINGS_GENERAL_ROUTE";
export const SETTINGS_PROFILE_ROUTE = "SETTINGS_PROFILE_ROUTE";
export const SETTINGS_ADMIN_ROUTE = "SETTINGS_ADMIN_ROUTE";
export const SETTINGS_BILLING_ROUTE = "SETTINGS_BILLING_ROUTE";
export const SETTINGS_INTEGRATIONS_ROUTE = "SETTINGS_INTEGRATIONS_ROUTE";
export const SETTINGS_DOWNLOADS_ROUTE = "SETTINGS_DOWNLOADS_ROUTE";
export const SETTINGS_CALL_SETTINGS_ROUTE = "SETTINGS_CALL_SETTINGS_ROUTE";
export const SETTINGS_CALL_AUDIO_ROUTE = "SETTINGS_CALL_AUDIO_ROUTE";
export const SETTINGS_CALL_PHONE_NUMBERS_ROUTE = "SETTINGS_CALL_PHONE_NUMBERS_ROUTE";
export const SETTINGS_BUY_NEW_NUMBER_ROUTE = "SETTINGS_BUY_NEW_NUMBER_ROUTE";
export const SETTINGS_CALL_RECORDINGS_ROUTE = "SETTINGS_CALL_RECORDINGS_ROUTE";
export const SETTINGS_ROLE_DETAIL_ROUTE = "SETTINGS_ROLE_DETAIL_ROUTE";
export const SETTINGS_AUTO_BUCKET_ROUTE = "SETTINGS_AUTO_BUCKET_ROUTE";

export const SUBSCRIPTION_ROUTE = "SUBSCRIPTION_ROUTE";
export const SUBSCRIPTION_WALL_ROUTE = "SUBSCRIPTION_WALL_ROUTE";
export const SUBSCRIPTION_SUCCESS_ROUTE = "SUBSCRIPTION_SUCCESS_ROUTE";
export const SUBSCRIPTION_CANCELLED_ROUTE = "SUBSCRIPTION_CANCELLED_ROUTE";
export const PAYMENT_SETUP_SUCCESS_ROUTE = "PAYMENT_SETUP_SUCCESS_ROUTE";

export const SUPPORT_ROUTE = "SUPPORT_ROUTE";

export const AI_AGENT_ROUTE = "AI_AGENT_ROUTE";

export const UNIPILE_SUCCESS_ROUTE = "UNIPILE_SUCCESS_ROUTE";
export const UNIPILE_ERROR_ROUTE = "UNIPILE_ERROR_ROUTE";

export const OAUTH_AUTHORIZE_ROUTE = "OAUTH_AUTHORIZE_ROUTE";

export const ERROR_ROUTE = "ERROR_ROUTE";
export const NOT_FOUND_404_ROUTE = "NOT_FOUND_404_ROUTE";

export const PRIVACY_POLICY_ROUTE = "PRIVACY_POLICY_ROUTE";
export const TERMS_OF_USE_ROUTE = "TERMS_OF_USE_ROUTE";
